<template>
    <div class="n-col-1">
        <div class="n-flex n-flex-a-c n-flex-j-sb">
            <h4 class="n-f-bold n-m-0 n-f-6 n-mb-2">{{ LAN.book.table.tables.replace('|COUNT|', total) }}</h4>
            <!-- 
            <div class="search-container n-flex n-flex-a-c">
                <a-input-search v-model:value="keyword"
                                enter-button
                                allowClear
                                size="large"
                                :placeholder="LAN.nui.common.pleaseEnterKeyword"
                                @search="searchData" />
            </div> -->
        </div>

        <div v-if="list?.length > 0"
             class="n-bg-1">
            <div v-for="(group, proupIndex) in list"
                 :key="proupIndex"
                 class="n-mb-1">
                <h3 class="n-f-bold n-f-4 n-m-0"
                    v-if="group.groupTitle && group.groupTitle != 'NA'">{{ group.groupTitle}}</h3>

                <ul class="n-ul n-p-0 list">
                    <template v-for="(item) in group.chapters"
                              :key="item">
                        <li v-if="item.chapterType == 'front-matter' || item.chapterType == 'back-matter'"
                            class="c-hover-preview">
                            <div class="n-ptb-2 n-b-line n-flex n-flex-a-e c-tab-link c-tab-link-event"
                                 @click="previewMatter(item)">
                                <div class="n-flex-g">
                                    <p class="n-block n-f-4 n-c-4 c-hover-target n-m-0 title"
                                       v-html="parseHilight(item.title, keyword)"></p>

                                    <span class="n-block n-c-4">{{ parseAuthors(item.chapterRelatedPerson) }}</span>

                                    <span class="n-block n-c-base"
                                          v-if="item.startPage && item.endPage">{{
                                           LAN.journal.pages }}
                                        {{ item.startPage }}-{{ item.endPage }}</span>
                                    <span v-else></span>
                                </div>
                                <div class="n-block n-text-right n-pointer"
                                     v-if="item.contentPdf.resourceUrl">
                                    <span class="n-c-base preview">{{ LAN.common.PDFPreview }}</span>
                                </div>
                            </div>
                        </li>

                        <li v-else
                            class="c-hover-normal n-pointer">
                            <router-link :to="{name: 'ChapterDetail', query: {id: item.id, bid }}"
                                         class="n-ptb-2 n-b-line n-flex n-flex-a-e c-tab-link c-tab-link-event">
                                <div class="n-flex-g">
                                    <p class="n-block n-f-4 n-c-4 c-hover-target n-m-0 title"
                                       v-html="parseHilight(item.title, keyword)"></p>

                                    <span class="n-block n-c-4">{{ parseAuthors(item.chapterRelatedPerson) }}</span>

                                    <span class="n-block n-c-base"
                                          v-if="item.startPage && item.endPage">{{
                                           LAN.journal.pages }}
                                        {{ item.startPage }}-{{ item.endPage }}</span>
                                    <span v-else></span>
                                </div>
                            </router-link>
                        </li>
                    </template>
                </ul>
            </div>
        </div>

        <a-row :gutter="[15, 15]"
               class="n-col-1"
               v-else>
            <a-col class="n-bg-1 n-ptb-3"
                   span="24">
                <a-empty :description="LAN.journal.noContents"></a-empty>
            </a-col>
        </a-row>

        <a-modal v-model:visible="previewMatterData.show"
                 centered
                 width="calc(100vw - 10px)"
                 height="calc(100vh - 10px)"
                 class="pdf-dialog"
                 v-if="previewMatterData.show"
                 :bodyStyle="{padding: 0}"
                 :title="previewMatterData.title"
                 :footer="null"
                 @ok="previewMatterData.show = false">
            <DocView :url="previewMatterData.contentPdf.resourceUrl"
                     :name="previewMatterData.contentPdf.originalName"></DocView>
        </a-modal>
    </div>
</template>
<script>
    import { mapMutations, mapState } from 'vuex';
    import { EditOutlined } from '@ant-design/icons-vue';
    import nui from '@/assets/script';
    import DocView from '@/components/nui/DocView/DocView.vue'

    export default {
        name: 'BookTable',
        props: {
            data: { type: Array, default: () => [] },
            contentPdfViewType: String,
            bid: String
        },
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                keyword: '',
                previewMatterData: { show: false },
                list: [],
                total: 0
            })
        },
        watch: {
            data: () => {
                this.searchData()
            }
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),

            NMounted () {
                var total = 0;

                this.data.forEach(item => {
                    total += item.chapters.length
                })

                this.total = total

                this.searchData()
            },
            searchData () {
                this.list = this.extend([], this.data.map(gItem => {
                    return {
                        chapters: gItem.chapters.filter(item => item.title.toLowerCase().indexOf(this.keyword.toLowerCase()) >= 0),
                        groupTitle: gItem.groupTitle
                    }
                }).filter(fItem => fItem.chapters.length > 0))
            },
            parseAuthors (data = []) {
                var res = JSON.parse(JSON.stringify(data.map(item => item.name)))

                if (res.length > 1) {
                    if (res.length == 2) {
                        return res.join(' and ')
                    } else {
                        res[res.length - 1] = 'and ' + res[res.length - 1]
                        return res.join(', ')
                    }
                } else {
                    return res.join(', ')
                }
            },
            previewMatter (data) {
                if ((this.contentPdfViewType || '') == 'NEW_WINDOW') {
                    window.open(`/web/viewer${this.data.isPdfReadOnly === 1 ? '_noop' : ''}.html?file=` + encodeURIComponent(data.contentPdf.resourceUrl), '_blank');
                } else {
                    this.previewMatterData = Object.assign({}, data, { show: true })
                }
            }
        }),
        components: {
            EditOutlined,
            DocView
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    .c-hover-normal,
    .c-hover-preview {
        transition: all 0.3s;
    }

    .c-hover-normal:hover {
        background-color: $background-color-2;
        padding-left: $margin-padding-2;

        .title {
            color: $color-base;
        }
    }

    .c-hover-preview:hover {
        .preview {
            text-decoration: underline;
        }
    }

    .thumb {
        width: 227px;
        height: 320px;

        .thumb-image {
            transition: all 0.3s;
        }
    }

    .title-icon {
        background-color: rgb(255, 226, 186);
        color: rgb(255, 162, 66);
        padding: 5px;
    }

    .view-title {
        background-color: rgb(56, 56, 61);
        color: #fff;
        height: 34px;
        line-height: 34px;
    }

    .view {
        background-color: rgb(42, 42, 46);

        li {
            background-color: rgb(42, 42, 46);
            color: #fff;

            a:after {
                background-color: #000;
            }
        }
    }

    .list {
        .n-b-line:after {
            height: 1px;
        }

        & > li {
            position: relative;

            i {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                background-image: $linear;
                background-color: transparent;
                opacity: 0;
                transition: all 0.3s;
            }

            &.c-hover {
                h1,
                p {
                    text-decoration: underline;
                }
            }

            &.c-hover:hover {
                h1,
                p {
                    color: $color-base;
                }

                i {
                    opacity: 1;
                }
            }
        }
    }
</style>